// unsafeGet :: forall r a. String -> Record r -> a
export function unsafeGet(label) {
  return function(record) {
    return record[label];
  };
}
